export class GatewayStateConfigurationsService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    async set(owner, configurations) {
        const commandResponse = await this.MessagingHubService.processCommand({
            method: 'set',
            to: owner,
            uri: '/state-configurations',
            type: 'application/json',
            resource: configurations,
        });
        return this.MessagingHubService.ensureCommandSuccess(commandResponse);
    }
}
GatewayStateConfigurationsService.$inject = ['MessagingHubService'];
